// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthLogoutRouteImport } from './routes/auth.logout'
import { Route as AuthLoginRouteImport } from './routes/auth.login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppPublishersIndexRouteImport } from './routes/_app/publishers/index'
import { Route as AppChannelsIndexRouteImport } from './routes/_app/channels/index'
import { Route as AppUsersUserIdRouteImport } from './routes/_app/users/$userId'
import { Route as AppPublishersPublisherIdRouteImport } from './routes/_app/publishers/$publisherId'
import { Route as AppChannelsChannelIdRouteImport } from './routes/_app/channels/$channelId'
import { Route as AppUsersUserIdIndexRouteImport } from './routes/_app/users/$userId/index'
import { Route as AppUsersUserIdChannelsRouteImport } from './routes/_app/users/$userId/channels'
import { Route as AppPublishersPublisherIdIndexRouteImport } from './routes/_app/publishers/$publisherId/index'
import { Route as AppPublishersPublisherIdUsersRouteImport } from './routes/_app/publishers/$publisherId/users'
import { Route as AppPublishersPublisherIdChannelsRouteImport } from './routes/_app/publishers/$publisherId/channels'
import { Route as AppChannelsChannelIdIndexRouteImport } from './routes/_app/channels/$channelId/index'
import { Route as AppChannelsChannelIdTeamRouteImport } from './routes/_app/channels/$channelId/team'
import { Route as AppChannelsChannelIdSettingsRouteImport } from './routes/_app/channels/$channelId/settings'
import { Route as AppChannelsChannelIdMonetizationRouteImport } from './routes/_app/channels/$channelId/monetization'
import { Route as AppChannelsChannelIdJinglesRouteImport } from './routes/_app/channels/$channelId/jingles'
import { Route as AppChannelsChannelIdGeolocationRouteImport } from './routes/_app/channels/$channelId/geolocation'
import { Route as AppChannelsChannelIdFilesRouteImport } from './routes/_app/channels/$channelId/files'
import { Route as AppChannelsChannelIdEpisodesRouteImport } from './routes/_app/channels/$channelId/episodes'
import { Route as AppChannelsChannelIdDirectoriesRouteImport } from './routes/_app/channels/$channelId/directories'
import { Route as AppChannelsChannelIdAudioRouteImport } from './routes/_app/channels/$channelId/audio'

const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AuthLogoutRoute = AuthLogoutRouteImport.update({
            id: '/auth/logout',path: '/auth/logout',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/auth/login',path: '/auth/login',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
            id: '/users/',path: '/users/',getParentRoute: () => AppRoute
          })
const AppPublishersIndexRoute = AppPublishersIndexRouteImport.update({
            id: '/publishers/',path: '/publishers/',getParentRoute: () => AppRoute
          })
const AppChannelsIndexRoute = AppChannelsIndexRouteImport.update({
            id: '/channels/',path: '/channels/',getParentRoute: () => AppRoute
          })
const AppUsersUserIdRoute = AppUsersUserIdRouteImport.update({
            id: '/users/$userId',path: '/users/$userId',getParentRoute: () => AppRoute
          })
const AppPublishersPublisherIdRoute = AppPublishersPublisherIdRouteImport.update({
            id: '/publishers/$publisherId',path: '/publishers/$publisherId',getParentRoute: () => AppRoute
          })
const AppChannelsChannelIdRoute = AppChannelsChannelIdRouteImport.update({
            id: '/channels/$channelId',path: '/channels/$channelId',getParentRoute: () => AppRoute
          })
const AppUsersUserIdIndexRoute = AppUsersUserIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppUsersUserIdRoute
          })
const AppUsersUserIdChannelsRoute = AppUsersUserIdChannelsRouteImport.update({
            id: '/channels',path: '/channels',getParentRoute: () => AppUsersUserIdRoute
          })
const AppPublishersPublisherIdIndexRoute = AppPublishersPublisherIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPublishersPublisherIdRoute
          })
const AppPublishersPublisherIdUsersRoute = AppPublishersPublisherIdUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AppPublishersPublisherIdRoute
          })
const AppPublishersPublisherIdChannelsRoute = AppPublishersPublisherIdChannelsRouteImport.update({
            id: '/channels',path: '/channels',getParentRoute: () => AppPublishersPublisherIdRoute
          })
const AppChannelsChannelIdIndexRoute = AppChannelsChannelIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppChannelsChannelIdRoute
          })
const AppChannelsChannelIdTeamRoute = AppChannelsChannelIdTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AppChannelsChannelIdRoute
          })
const AppChannelsChannelIdSettingsRoute = AppChannelsChannelIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppChannelsChannelIdRoute
          })
const AppChannelsChannelIdMonetizationRoute = AppChannelsChannelIdMonetizationRouteImport.update({
            id: '/monetization',path: '/monetization',getParentRoute: () => AppChannelsChannelIdRoute
          })
const AppChannelsChannelIdJinglesRoute = AppChannelsChannelIdJinglesRouteImport.update({
            id: '/jingles',path: '/jingles',getParentRoute: () => AppChannelsChannelIdRoute
          })
const AppChannelsChannelIdGeolocationRoute = AppChannelsChannelIdGeolocationRouteImport.update({
            id: '/geolocation',path: '/geolocation',getParentRoute: () => AppChannelsChannelIdRoute
          })
const AppChannelsChannelIdFilesRoute = AppChannelsChannelIdFilesRouteImport.update({
            id: '/files',path: '/files',getParentRoute: () => AppChannelsChannelIdRoute
          })
const AppChannelsChannelIdEpisodesRoute = AppChannelsChannelIdEpisodesRouteImport.update({
            id: '/episodes',path: '/episodes',getParentRoute: () => AppChannelsChannelIdRoute
          })
const AppChannelsChannelIdDirectoriesRoute = AppChannelsChannelIdDirectoriesRouteImport.update({
            id: '/directories',path: '/directories',getParentRoute: () => AppChannelsChannelIdRoute
          })
const AppChannelsChannelIdAudioRoute = AppChannelsChannelIdAudioRouteImport.update({
            id: '/audio',path: '/audio',getParentRoute: () => AppChannelsChannelIdRoute
          })





const AppChannelsChannelIdRouteChildren = {
  AppChannelsChannelIdAudioRoute: AppChannelsChannelIdAudioRoute,AppChannelsChannelIdDirectoriesRoute: AppChannelsChannelIdDirectoriesRoute,AppChannelsChannelIdEpisodesRoute: AppChannelsChannelIdEpisodesRoute,AppChannelsChannelIdFilesRoute: AppChannelsChannelIdFilesRoute,AppChannelsChannelIdGeolocationRoute: AppChannelsChannelIdGeolocationRoute,AppChannelsChannelIdJinglesRoute: AppChannelsChannelIdJinglesRoute,AppChannelsChannelIdMonetizationRoute: AppChannelsChannelIdMonetizationRoute,AppChannelsChannelIdSettingsRoute: AppChannelsChannelIdSettingsRoute,AppChannelsChannelIdTeamRoute: AppChannelsChannelIdTeamRoute,AppChannelsChannelIdIndexRoute: AppChannelsChannelIdIndexRoute
}

const AppChannelsChannelIdRouteWithChildren = AppChannelsChannelIdRoute._addFileChildren(AppChannelsChannelIdRouteChildren)




const AppPublishersPublisherIdRouteChildren = {
  AppPublishersPublisherIdChannelsRoute: AppPublishersPublisherIdChannelsRoute,AppPublishersPublisherIdUsersRoute: AppPublishersPublisherIdUsersRoute,AppPublishersPublisherIdIndexRoute: AppPublishersPublisherIdIndexRoute
}

const AppPublishersPublisherIdRouteWithChildren = AppPublishersPublisherIdRoute._addFileChildren(AppPublishersPublisherIdRouteChildren)




const AppUsersUserIdRouteChildren = {
  AppUsersUserIdChannelsRoute: AppUsersUserIdChannelsRoute,AppUsersUserIdIndexRoute: AppUsersUserIdIndexRoute
}

const AppUsersUserIdRouteWithChildren = AppUsersUserIdRoute._addFileChildren(AppUsersUserIdRouteChildren)



const AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,AppChannelsChannelIdRoute: AppChannelsChannelIdRouteWithChildren,AppPublishersPublisherIdRoute: AppPublishersPublisherIdRouteWithChildren,AppUsersUserIdRoute: AppUsersUserIdRouteWithChildren,AppChannelsIndexRoute: AppChannelsIndexRoute,AppPublishersIndexRoute: AppPublishersIndexRoute,AppUsersIndexRoute: AppUsersIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  AppRoute: AppRouteWithChildren,AuthLoginRoute: AuthLoginRoute,AuthLogoutRoute: AuthLogoutRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)